import Loadable from "@loadable/component";

const thankYou = Loadable(
  () => import(/* webpackChunkName: "thank_you_page" */ "./thankYou")
);

export default thankYou;
